export enum OfferProductTemplateType {
    // Offres actuelles
    OFFER_FREE = 4,
    OFFER_PRO = 6,
    OFFER_MAX = 10,
    OFFER_ENTERPRISE = 14,
    OFFER_AGENCY = 15,

    // Offres désactivées
    OFFER_ESSENTIEL = 5,

    // Offres legacy (100% blog)
    BLOG_ESSENTIEL_LEGACY = 11,
    BLOG_PRO_LEGACY = 12,
    BLOG_ENTREPRISE_LEGACY = 13
}